function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#33C100;}\n\t.st1{fill:#BFE6E5;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Icon_3");

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st0 achievements1",
  cx: 19,
  cy: 17.8,
  r: 7.8
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st0 achievements2",
  cx: 19,
  cy: 37.6,
  r: 7.8
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st0 achievements3",
  cx: 19,
  cy: 57.5,
  r: 7.8
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st0 achievements4",
  cx: 19,
  cy: 77.3,
  r: 7.8
});

var _ref8 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st0 achievements5",
  cx: 19,
  cy: 97.1,
  r: 7.8
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 36.5,
  y: 13.3,
  className: "st1 achievements1",
  width: 66.3,
  height: 9.9
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 36.5,
  y: 33,
  className: "st1 achievements2",
  width: 66.3,
  height: 9.9
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 36.5,
  y: 52.7,
  className: "st1 achievements3",
  width: 66.3,
  height: 9.9
});

var _ref12 =
/*#__PURE__*/
React.createElement("rect", {
  x: 36.5,
  y: 72.4,
  className: "st1 achievements4",
  width: 66.3,
  height: 9.9
});

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: 36.5,
  y: 92.2,
  className: "st1 achievements5",
  width: 66.3,
  height: 9.9
});

var SvgIcon3 = function SvgIcon3(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115 115",
    style: {
      enableBackground: "new 0 0 115 115"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcon3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_3.8b3d2ae9.svg";
export { ForwardRef as ReactComponent };